import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyBRjQ9RFRegLr0V0UlPpw9_wfH0nNlXJak',
  authDomain: 'beneat-admin.firebaseapp.com',
  projectId: 'beneat-admin',
  storageBucket: 'beneat-admin.appspot.com',
  messagingSenderId: '472609840914',
  appId: '1:472609840914:web:4ed28753bf0e0366269dcb'
}

const app = initializeApp(firebaseConfig)
const auth = getAuth(app)

export {
  auth
}
